import React from 'react';

import LinkifiedText from '../../../../shared/LinkifiedText/LinkifiedText';

import './AdminCardField.css';

const AdminCardField = ({ children = '', label = '', type }) => {
  const contentClassNames = [`admin-card-field-content-${type}`].join(' ');

  return (
    <div className='admin-card-field-container'>
      <label className='admin-card-field-title'>{label}</label>
      <div className={contentClassNames}>{renderValue(children, type)}</div>
    </div>
  );
};

const renderValue = (value, type) => {
  if (type === 'checkbox') {
    return value ? <div>✓&nbsp;Yes</div> : <div>✗&nbsp;No</div>;
  }

  if (type === 'number') {
    return value;
  }

  if (type === 'currency') {
    return `$${value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  if (type === 'date') {
    if (!value) return <span>-</span>;
    const dateObj = new Date(value);
    return dateObj.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    });
  }

  if (type === 'tags') {
    if (!Array.isArray(value) || value.length === 0) return <span>-</span>;
    return (
      <div className='admin-card-field-tags'>
        {value.map((tag, index) => (
          <span key={index} className='admin-card-field-tag'>
            {tag}
          </span>
        ))}
      </div>
    );
  }

  if (type === 'categories') {
    if (!Array.isArray(value) || value.length === 0) return <span>-</span>;
    return (
      <div className='admin-card-field-categories'>
        {value.map((category, index) => (
          <span key={index} className='admin-card-field-category'>
            {category.name}
          </span>
        ))}
      </div>
    );
  }

  if (type === 'author') {
    if (!value || typeof value !== 'object' || !value.name)
      return <span>-</span>;
    return (
      <LinkifiedText className='admin-card-field-link'>
        {value.name}
      </LinkifiedText>
    );
  }

  if (
    type === 'text' ||
    type === 'textarea' ||
    type === 'url' ||
    type === 'email'
  ) {
    return (
      <LinkifiedText className='admin-card-field-link'>{value}</LinkifiedText>
    );
  }

  return <span>{value}</span>;
};

export default AdminCardField;
